var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouterHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85001 16.6666C8.30834 16.6583 6.96167 16.6075 5.41501 16.5341C4.36334 16.4775 3.42084 15.8058 3.07334 14.8625C2.18751 12.4608 2.05334 11.2858 1.72834 8.44829L1.68584 8.07996C1.59001 7.22746 1.84001 6.38163 2.39084 5.69996C2.97751 4.97413 3.82417 4.52246 4.77334 4.42913C6.31667 4.27746 8.17001 4.18163 9.85751 4.16663C11.5883 4.18246 13.5067 4.27746 15.1042 4.42913C16.1017 4.52413 17.02 5.00663 17.6217 5.75246C18.1642 6.42413 18.41 7.24996 18.3133 8.07829L18.2792 8.36663C17.9425 11.2425 17.8033 12.4316 16.8792 14.8533C16.5125 15.8166 15.5508 16.4766 14.4308 16.535C12.8308 16.6075 11.4367 16.6583 9.85001 16.6666Z",
    fill: "#BDCEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1833 3.60004C13.6917 3.45837 11.75 3.35004 9.84999 3.33337C8.00832 3.35004 6.13332 3.45837 4.69166 3.60004C2.32499 3.83337 0.599989 5.89171 0.858322 8.17504C1.21666 11.2917 1.33332 12.55 2.29166 15.15C2.75832 16.4167 3.98332 17.2917 5.37499 17.3667C6.95832 17.4417 8.30832 17.4917 9.84999 17.5C11.4417 17.4917 12.8333 17.4417 14.475 17.3667C15.9167 17.2917 17.175 16.4167 17.6583 15.15C18.65 12.55 18.775 11.2917 19.1417 8.17504C19.4083 5.89171 17.625 3.83337 15.1833 3.60004ZM15.325 15.0917C15.1917 15.425 14.7917 15.675 14.3583 15.7C12.7 15.7834 11.375 15.825 9.84999 15.8334C8.38332 15.825 7.09166 15.7834 5.49999 15.7C5.10832 15.6834 4.75832 15.4417 4.64166 15.1167C3.91666 13.1584 3.34166 8.72504 3.34166 8.72504C3.29999 8.31671 3.41666 7.90837 3.69166 7.57504C3.99166 7.20004 4.43332 6.96671 4.93332 6.92504C6.54166 6.76671 8.28332 6.68337 9.84999 6.67504C11.4667 6.68337 13.275 6.76671 14.95 6.92504C15.5 6.97504 16 7.23337 16.325 7.63337C16.5083 7.85837 16.7167 8.23337 16.6583 8.71671C16.6583 8.71671 16.0667 13.1417 15.325 15.0917Z",
    fill: "url(#paint0_linear_1996_36331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66668 14.1667C7.12691 14.1667 7.50001 13.7936 7.50001 13.3333C7.50001 12.8731 7.12691 12.5 6.66668 12.5C6.20644 12.5 5.83334 12.8731 5.83334 13.3333C5.83334 13.7936 6.20644 14.1667 6.66668 14.1667Z",
    fill: "url(#paint1_linear_1996_36331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 14.1667C10.4602 14.1667 10.8333 13.7936 10.8333 13.3333C10.8333 12.8731 10.4602 12.5 9.99999 12.5C9.53975 12.5 9.16666 12.8731 9.16666 13.3333C9.16666 13.7936 9.53975 14.1667 9.99999 14.1667Z",
    fill: "url(#paint2_linear_1996_36331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.1667C13.7936 14.1667 14.1667 13.7936 14.1667 13.3333C14.1667 12.8731 13.7936 12.5 13.3333 12.5C12.8731 12.5 12.5 12.8731 12.5 13.3333C12.5 13.7936 12.8731 14.1667 13.3333 14.1667Z",
    fill: "url(#paint3_linear_1996_36331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1996_36331",
    x1: 10.0004,
    y1: 3.33337,
    x2: 10.0004,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4873F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1996_36331",
    x1: 6.66668,
    y1: 12.5,
    x2: 6.66668,
    y2: 14.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4873F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1996_36331",
    x1: 9.99999,
    y1: 12.5,
    x2: 9.99999,
    y2: 14.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4873F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1996_36331",
    x1: 13.3333,
    y1: 12.5,
    x2: 13.3333,
    y2: 14.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4873F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouterHover);
export default __webpack_public_path__ + "static/media/router-hover.3ed486d50ee3f78f17a7eff544fdc1f4.svg";
export { ForwardRef as ReactComponent };